import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, Typography, withTypography } from 'components/ui';
import type { BoxProps, TypographyProps } from 'components/ui';
import { getDesignToken, spacing } from 'styles/constants';

export const ItemContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.itemContainer, style],
  });

export const ItemName = ({ isAvailable, ...props }: TypographyProps & { isAvailable: boolean }) =>
  React.createElement(Typography, {
    ...props,
    color: isAvailable ? getDesignToken('text-default') : getDesignToken('text-disabled'),
    fontFamily: 'heading',
    mt: '$2',
  });

export const PictureContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.pictureContainer, style],
  });

export const DetailsContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.detailsContainer, style],
  });

export const ItemInfoContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.itemInfoContainer, style],
  });

export const InfoText = withTypography({
  ml: '$2',
});

const styles = StyleSheet.create({
  detailsContainer: {
    flex: 1,
    marginLeft: spacing.$4,
  },
  itemContainer: {
    alignItems: 'center',
    backgroundColor: getDesignToken('background-pattern'),
    borderTopColor: getDesignToken('border-default'),
    borderTopWidth: 1,
    flexDirection: 'row',
    paddingHorizontal: spacing.$4,
    paddingVertical: spacing.$3,
    width: '100%',
  },
  itemInfoContainer: {
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    flexDirection: 'row',
    marginTop: spacing.$1,
    paddingHorizontal: spacing.$4,
    paddingVertical: spacing.$2,
  },
  pictureContainer: {
    alignItems: 'center',
    height: spacing.$17,
    width: spacing.$19,
  },
});
